import { Text, makeStyles } from '@rneui/themed'
import { font } from 'app/theme'
import { Modal, Pressable, View } from 'react-native'
import { PressableOpacity } from 'shared/components/pressable_opacity'

export function EventDescriptionModal({
  visible,
  description,
  setModalVisible,
  title,
}: {
  visible: boolean
  description: string
  title: string
  setModalVisible: React.Dispatch<React.SetStateAction<boolean>>
}) {
  const styles = useStyles()

  return (
    <Modal animationType="fade" transparent={true} visible={visible}>
      <Pressable
        onPress={() => setModalVisible(false)}
        style={styles.modalBackDrop}
      >
        <View style={styles.modalContainer}>
          <View style={styles.modalView}>
            <View style={styles.closeButtonContainer}>
              <Text style={styles.modalTitle}>{title}</Text>
              <PressableOpacity
                style={styles.closeButton}
                onPress={() => setModalVisible(false)}
              >
                <Text style={styles.closeButtonText}>X</Text>
              </PressableOpacity>
            </View>
            <Text style={styles.modalText}>{description}</Text>
          </View>
        </View>
      </Pressable>
    </Modal>
  )
}

const useStyles = makeStyles(theme => ({
  modalContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    margin: 20,
  },
  modalView: {
    margin: 5,
    backgroundColor: theme.colors?.grey5,
    borderRadius: 20,
    padding: 20,
    shadowColor: theme.colors?.black,
    shadowOffset: {
      width: 0,
      height: 2,
    },
    shadowOpacity: 0.25,
    shadowRadius: 4,
    elevation: 5,
  },

  modalText: {
    marginBottom: 15,
    fontSize: 18,
    color: theme.colors?.black,
  },
  modalBackDrop: {
    flex: 1,
    backgroundColor: 'rgba(0, 0, 0, 0.50)',
  },
  closeButtonContainer: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 10,
  },
  closeButton: {
    backgroundColor: theme.colors?.grey3,
    width: 20,
    height: 20,
    borderRadius: 10,
    alignItems: 'center',
    justifyContent: 'center',
  },
  closeButtonText: {
    fontSize: 10,
    fontFamily: font.bold,
    color: theme.colors?.white,
  },
  modalTitle: {
    color: theme.colors.black,
    fontSize: 20,
    fontFamily: font.bold,
  },
}))
